<template>
  <div>
    <div>
      <div class="indexbf-top indexbefore-bg">
        <img
          src="../../assets/robot/bg.jpeg"
          alt=""
          class="indexbefore-bg-img"
        />
      </div>
      <div>
        <div class="shangxian">产品即将上线,敬请期待!</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    this.$alert('产品即将上线,敬请期待!', '提示', {
      type: 'warning',
    })
  },

  mounted() {},
}
</script>
<style>
.robot .selected {
  color: #409eff;
  font-weight: 700;
}
</style>

<style lang="stylus" scoped>
.loginbox {
  width: 458px;
  height: 500px;
  background: #fff;
  border-radius: 3px;
  box-shadow: 0 2px 12px rgba(0 0 0 0.45);
  position: absolute;
  top: 86px;
  left: 50%;
  transform: translateX(-50%);
}

.loginbox1 {
  width: 458px;
  background: #fff;
  border-radius: 3px;
  box-shadow: 0 2px 12px rgba(0 0 0 0.45);
  position: absolute;
  top: 86px;
  left: 50%;
  transform: translateX(-50%);
}

.loginbox3 {
  width: 800px;
  background: #fff;
  border-radius: 3px;
  box-shadow: 0 2px 12px rgba(0 0 0 0.45);
  position: absolute;
  top: 86px;
  left: 50%;
  transform: translateX(-50%);
}

.loginTipFont {
  font-size: 20px;
  color: #686868;
  font-family: Microsoft YaHei;
  font-weight: 400;
  margin-top: 20px;
  margin-left: 33px;
}

.qyyw {
  width: 100%;
  text-align: center;
  heigit: 40px;
  line-height: 40px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  color: #505050;
  font-weight: 700;
  border-bottom: 2px solid #0066d1;
}

.formContent {
  padding: 10px 20px 20px;
}

.card {
  width: 100%;
  font-size: 14px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.selected {
  width: 136px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border-radius: 2px;
  background-color: #168de9;
  color: #e5eefa;
}

.inputbox {
  margin-top: 14px;
}

.creditCode {
  background: url('../../assets/robot/a.png') no-repeat 1px 9px !important;
}

.creditCode1 {
  background: url('../../assets/robot/b.png') no-repeat 1px 9px !important;
}

.creditCode2 {
  background: url('../../assets/robot/c.png') no-repeat 1px 9px !important;
}

.creditCode4 {
  background: url('../../assets/robot/d.png') no-repeat 1px 9px !important;
}

/deep/ .el-form-item {
  margin-bottom: 17px;
}

/deep/ .el-input.is-disabled .el-input__inner {
  background-color: white;
  cursor: text;
}

/deep/ .el-input.is-disabled .el-input__icon {
  cursor: text;
}

.zdkq {
  display: flex;
  align-items: center;
  margin-bottom: 17px;
}

.qydl {
  height: 100%;
  padding-bottom: 12px;
  box-sizing: border-box;
}

.tabsCls {
  width: 100%;
  height: 85px;
  border-bottom: 2px solid #bbb;
}

.llk {
  height: 4px;
  box-sizing: border-box;
}

.tabSelect {
  height: 2px;
  background: #0066d1;
}

.justifyCenterEnd {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  text-align: center;
}

.duanxin {
  width: calc(100% - 130px);
}

/deep/ .nonheader .el-dialog__header {
  display: none;
}

/deep/.el-checkbox.is-bordered.is-checked {
  border-color: #409EFF;
}

.cx_card {
  width: 200px;
  height: 100px;
  text-align: center;
  line-height: 50px;
  background-color: #ff7a00;
  color: white;
  cursor: pointer;
}

.cx {
  display: flex;
  justify-content: center;
  margin-top: -50px;
}

/deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
  border-color: #409eff;
  background: #409eff;
}

/deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #409EFF;
}

/deep/ .el-radio__input.is-checked + .el-radio__label {
  color: #409EFF;
}

/deep/.el-radio__input.is-checked .el-radio__inner {
  border-color: #409eff;
  background: #409eff;
}

.agree {
  margin-left: 50px;
  margin-top: 20px;
  display: flex;
}

.xieyi {
  margin-left: 10px;
  color: #409EFF;
  cursor: pointer;
}

.lxieyi {
  text-align: center;
  color: #409EFF;
  cursor: pointer;
  margin-top: 10px;
}

.login {
  display: flex;
  justify-content: center;
  align-items: center;
}

/deep/ .el-input.is-disabled .el-input__inner {
  color: black;
}

.tishi {
  text-align: center;
}

.center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.qrclass {
  width: 100%;
  height: 350px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.daoqi {
  text-align: center;
  color: red;
  font-size: 18px;
}

.product {
  text-align: center;
  margin-top: 10px;
  font-size: 16px;
}

/deep/ .el-select .el-input.is-focus .el-input__inner {
  border-color: #409EFF;
}

/deep/ .el-button--primary.is-plain {
  color: #409EFF;
  background: #ecf5ff;
  border-color: #b3d8ff;
}

/deep/ .el-input__inner:focus {
  border-color: #d9d9d9;
}

/deep/ .el-menu--horizontal > .el-menu-item {
  height: 40px;
  line-height: 40px;
}

.shtitle {
  padding-top: 20px;
  padding-bottom: 20px;
  text-align: center;
  font: normal 14px / 20px arial, sans-serif;
}

.messageCode {
  display: flex;
  justify-content: space-between;
}

.indexbf-top {
  overflow: visible;
  width: 100%;
  height: 460px;
  background-size: 100% 100%;
  box-sizing: border-box;
  position: relative;
}

.indexbefore-bg-img {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: -1;
  top: 0;
  left: 0;
  vertical-align: middle;
}

.wenxin {
  text-align: center;
}

.shuoming {
  color: black;
  font-size: 16px;
}

.nexttshi {
  margin-top: 10px;
  display: flex;
  justify-content: center;
}

.dialog-footer {
  margin-top: 10px;
  display: flex;
  justify-content: center;
}

.xieyiinfo {
  height: 500px;
  overflow: auto;
}

.shangxian {
  text-align: center;
  font-size: 18px;
  font-weight: blod;
  margin-top: 20px;
}
</style>
